import { z } from "zod";

export const reportsFiltersSchema = z.object({
  status: z.string().optional(),
  partner_name: z.string().optional(),
  client_name: z.string().optional(),
  client_cpf: z.string().optional(),
  sale_id: z.string().optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  minimum_price: z.string().optional(),
  maximum_price: z.string().optional(),
});

export type TReportsFiltersFormData = z.infer<typeof reportsFiltersSchema>;

